export function populateRansomActionBox(entry, container, timelineElement) {
    container.addClass("ransom_action");
    var clonedBox = $(".ransom_action_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("ransom_action_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("ransom_action_box");
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
    clonedBox.find(".prost_count").text(entry.sum_prosts);
    clonedBox.find(".content").html(entry.content);
    getRansomAction(entry.id, timelineElement);
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}